import { Button, Modal } from 'antd';
import CheckCircleFill2Icon from 'assets/icons/check-circle-fill-2.svg';

interface props {
    open: boolean;
    onCancel: () => void | Promise<void>;
    onOk?: () => void | Promise<void>;
    description?: string;
}

export const ConfirmModalComponent = ({ open, onCancel, onOk, description }: props) => {
    return (
        <Modal width={327} open={open} footer={null} centered className="modal-info">
            <section style={{ paddingTop: 12, paddingBottom: 4 }}>
                <div style={{ width: '100%' }} className="center-inside">
                    <img src={CheckCircleFill2Icon} alt="" />
                </div>
                <div className="confirm-modal-2-title" style={{ marginBottom: 8, marginTop: 32 }}>
                    査定依頼を受け付けました
                </div>
                <div className="confirm-modal-2-description" style={{ marginBottom: 32 }}>
                    {description}
                </div>
                {onOk && (
                    <Button
                        type="primary"
                        className="button-login-text"
                        style={{ width: '100%', height: 48, marginBottom: 32 }}
                        onClick={() => onOk()}
                    >
                        本人確認に進む
                    </Button>
                )}
                <Button
                    type="primary"
                    className="button-login-text"
                    style={{ width: '100%', height: 48 }}
                    onClick={() => onCancel()}
                >
                    ダッシュボードに戻る
                </Button>
            </section>
        </Modal>
    );
};
